import {
  googleMapsApiKey,
  mapProvider,
  osmNominatimUrl,
  osmOsrmUrl,
  osmPhotonUrl,
} from '../environment';

export type MapProvider = 'google' | 'osm';

export type OsmEndpoints = {
  nominatimUrl: string;
  photonUrl: string;
  osrmUrl: string;
};

export type GeoConfig = {
  provider: MapProvider;
  googleApiKey: string;
  osm: OsmEndpoints;
};

export type RawGeoEnv = {
  mapProvider?: string;
  googleMapsApiKey?: string;
  nominatimUrl?: string;
  photonUrl?: string;
  osrmUrl?: string;
};

// Зона поиска подсказок адресов
export const SEARCH_AREA = {
  lat: 55.3808455416306,
  lng: 50.43205871583283,
  radiusKm: 200,
  countryCode: 'RU',
};

const DEFAULT_OSM_ENDPOINTS: OsmEndpoints = {
  nominatimUrl: 'https://nominatim.openstreetmap.org',
  photonUrl: 'https://photon.komoot.io',
  osrmUrl: 'https://router.project-osrm.org',
};

const resolveProvider = (value?: string): MapProvider => {
  if (!value || value === 'osm') return 'osm';
  if (value === 'google') return 'google';
  console.warn(`Unknown VITE_MAP_PROVIDER "${value}", falling back to osm`);
  return 'osm';
};

// Пустая строка означает «не задано»
const resolveUrl = (value: string | undefined, fallback: string): string =>
  (value || fallback).replace(/\/+$/, '');

export function resolveGeoConfig(raw: RawGeoEnv): GeoConfig {
  return {
    provider: resolveProvider(raw.mapProvider),
    googleApiKey: raw.googleMapsApiKey || '',
    osm: {
      nominatimUrl: resolveUrl(raw.nominatimUrl, DEFAULT_OSM_ENDPOINTS.nominatimUrl),
      photonUrl: resolveUrl(raw.photonUrl, DEFAULT_OSM_ENDPOINTS.photonUrl),
      osrmUrl: resolveUrl(raw.osrmUrl, DEFAULT_OSM_ENDPOINTS.osrmUrl),
    },
  };
}

export const geoConfig: GeoConfig = resolveGeoConfig({
  mapProvider,
  googleMapsApiKey,
  nominatimUrl: osmNominatimUrl,
  photonUrl: osmPhotonUrl,
  osrmUrl: osmOsrmUrl,
});
